<template>
    <div>
        <h5 class="text-dark mt-5">Documents</h5>
        <div class="table-header font-weight-bold text-white w-100 p-2">Files</div>
        <div class="bg-white w-100 border-light px-3 mb-4">
            <div class="row mt-2">
                <div class="col-12 col-md-3 my-2">
                    <v-date-picker
                        dusk="date"
                        placeholder="MM/DD/YYYY"
                        id="date"
                        class="picker-container"
                        popover-align="left"
                        v-model="newFile.date"
                    ></v-date-picker>
                </div>
                <div class="col-12 col-md-3 my-2">
                    <input type="text" class="form-control" v-model="newFile.name" />
                </div>

                <div class="col-12 col-md-3 my-2">
                    <label for="file"
                        >Attach a file
                        <i
                            class="fa fa-info-circle text-info"
                            v-tooltip="`File size limited to 50MB`"
                        ></i
                    ></label>
                    <input
                        id="file"
                        name="file"
                        type="file"
                        class="form-control-file"
                        ref="file"
                        @change="handleFile"
                    />
                </div>
                <div class="col-12 col-md-1 my-2">
                    <div class="save-button-container mb-2">
                        <button
                            :disabled="loading"
                            @click.prevent="handleSave"
                            class="btn btn-sm btn-primary font-weight-bold text-white text-uppercase d-inline-block"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="error" class="alert alert-danger"><strong>Error!</strong> {{ error }}</div>

            <div v-if="success" class="alert alert-success">
                <strong>Success!</strong> Your document was saved
            </div>

            <div v-if="loading" class="loading-container">
                <i class="fa fa-spin fa-circle-o-notch mr-2"></i>
            </div>

            <table class="table table-striped">
                <colgroup>
                    <col span="1" style="width: 25.0%;" />
                    <col span="1" style="width: 35.0%;" />
                    <col span="1" style="width: 25.0%;" />
                    <col span="1" style="width: 15.0%;" />
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Name</th>
                        <th scope="col">File</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="file in files" :key="file.id">
                        <td>
                            {{ file.date ? moment(file.date).format("MM/DD/YYYY") : "Not entered" }}
                        </td>
                        <td>{{ file.file_name }}</td>
                        <td>
                            <a
                                data-toggle="tooltip"
                                data-placement="top"
                                v-bind:href="file.file_url"
                                v-bind:title="file.file_name"
                            >
                                <i :class="file.file_url ? 'fa fa-file' : ''"></i>
                            </a>
                        </td>
                        <td>
                            <template>
                                <div class="dropdown text-right">
                                    <button
                                        class="btn btn-sm btn-link text-black"
                                        type="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <i class="fa fa-ellipsis-v"></i>
                                    </button>
                                    <div
                                        class="dropdown-menu dropdown-menu-right"
                                        aria-labelledby="delete-recurring"
                                    >
                                        <a
                                            class="cursor-pointer dropdown-item small"
                                            @click="showeditFile(file)"
                                            >Edit Document</a
                                        >
                                        <a
                                            class="cursor-pointer dropdown-item small text-danger"
                                            @click="confirmdeleteFile(file.id)"
                                            >Delete Document</a
                                        >
                                    </div>
                                </div>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <modal-component
            :id="'modal-file'"
            :visible="modal.visible"
            :title="modal.title"
            :size="modal.size"
            @close="resetModal()"
        >
            <div v-show="selectedAction === 'delete'">
                <p class="">Are you sure you want to delete this document?</p>
                <a
                    class="btn btn-sm btn-primary font-weight-bold text-white text-uppercase btn-block m-1"
                    @click="deleteFile()"
                    ><small
                        v-html="
                            loading
                                ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i> Deleting...`
                                : `Yes, permanently delete this document.  `
                        "
                    ></small
                ></a>
            </div>
            <div v-show="selectedAction === 'edit'">
                <form>
                    <div class="form-group row mb-2">
                        <label
                            for="document-date"
                            class="col-4 col-form-label font-weight-bold text-nowrap text-capitalize"
                            >Date:</label
                        >
                        <div class="col-8">
                            <v-date-picker
                                dusk="date"
                                placeholder="MM/DD/YYYY"
                                id="editdate"
                                class="picker-container"
                                popover-align="left"
                                v-model="editFile.date"
                            ></v-date-picker>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <label
                            for="document-name"
                            class="col-4 col-form-label font-weight-bold text-nowrap text-capitalize"
                            >Name:</label
                        >
                        <div class="col-8">
                            <input
                                id="document-name"
                                type="text"
                                class="form-control"
                                v-model="editFile.name"
                            />
                        </div>
                    </div>

                    <div class="d-flex w-100 justify-content-end">
                        <button
                            :disabled="loading"
                            @click.prevent="patchFile()"
                            class="btn btn-sm btn-primary font-weight-bold text-white text-uppercase d-inline-block"
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </modal-component>
    </div>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
import ProfilePicture from "../ui/ProfilePicture";
import { fixDatePickers } from "../../plugins/fixDatePickers";

export default {
    name: "ManageCompanyDocuments",
    props: ["userType", "apiEndpoints", "organization"],
    mixins: [fixDatePickers],
    components: {
        ModalComponent,
        ProfilePicture,
    },
    data() {
        return {
            search: null,
            newFile: this.getInitialnewFileData(),
            currentFile: null,
            editFile: {},
            files: [],
            error: null,
            success: false,
            loading: false,
            selectedAction: null,
            modal: {
                visible: false,
                size: null,
                title: null,
            },
        };
    },
    mounted() {
        if (this.organization) {
            this.getFilesData();
        }
    },
    watch: {
        organization() {
            this.getFilesData();
        },
    },
    methods: {
        confirmdeleteFile(id) {
            this.selectedAction = "delete";
            this.currentFile = id;
            this.modal.size = "sm";
            this.modal.visible = true;
        },
        showeditFile(file) {
            this.selectedAction = "edit";
            this.editFile = { ...file };
            this.editFile.date = this.moment(this.editFile.date).toDate();
            this.modal.title = "Edit Document";
            this.modal.size = null;
            this.modal.visible = true;
        },
        resetModal() {
            this.modal.visible = false;
            this.modal.title = null;
            this.modal.size = null;
            this.currentFile = null;
            this.editFile = {};
        },
        getFilesData() {
            this.loading = true;
            axios
                .get(`/api/organizations/${this.organization.id}/company-documents`)
                .then(r => {
                    this.files = r.data.data;
                    this.error = null;
                    this.loading = false;
                    $('[data-toggle="tooltip"]').tooltip();
                })
                .catch(e => {
                    this.error = "Could not retrieve internal files. Server error.";
                    this.loading = false;
                    $('[data-toggle="tooltip"]').tooltip();
                });
        },
        patchFile() {
            let payload = { ...this.editFile };
            payload.date = this.moment(payload.date).format("YYYY-MM-DD");
            axios
                .patch(
                    `/api/organizations/${this.organization.id}/company-documents/${payload.id}`,
                    payload
                )
                .then(r => {
                    this.getFilesData();
                    this.resetModal();
                    this.loading = false;
                })
                .catch(e => {
                    this.error = "Could not save. Please check your values or try again later.";
                    this.resetModal();
                    this.loading = false;
                });
        },
        handleSave(e) {
            const payload = new FormData();
            payload.append("date", this.moment(this.newFile.date).format("YYYY-MM-DD"));
            payload.append("name", this.newFile.name);
            if (this.newFile.file) {
                payload.append("file", this.newFile.file);
            }

            this.loading = true;
            axios
                .post(`/api/organizations/${this.organization.id}/company-documents`, payload)
                .then(r => {
                    // add file locally
                    this.files.push(r.data.data);
                    // reset form state
                    this.error = null;
                    this.newFile = this.getInitialnewFileData();
                    this.$refs.file.value = "";
                    // show success banner
                    this.success = true;
                    const self = this;
                    setTimeout(() => {
                        self.success = false;
                    }, 3000);
                    this.loading = false;
                })
                .catch(e => {
                    this.error = "Could not save. Please check your values or try again later.";
                    this.loading = false;
                });
        },
        handleFile() {
            const files = this.$refs.file.files;
            this.newFile.file = files[0];
        },
        getInitialnewFileData() {
            return {
                date: new Date(),
                name: "",
                file: null,
            };
        },
        openActionsMenu(fileId) {
            this.currentFile = fileId;
            this.selectedAction = null;
            this.modal.visible = true;
            this.modal.title = "File";
        },
        deleteFile() {
            this.loading = true;
            axios
                .delete(
                    `/api/organizations/${this.organization.id}/company-documents/${
                        this.currentFile
                    }`
                )
                .then(response => {
                    this.loading = false;
                    this.resetModal();
                    this.getFilesData();
                })
                .catch(e => {
                    this.loading = false;
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../../sass/_variables.scss";
.save-button-container {
    text-align: center;
}
@media #{$breakpoint-small} {
    .save-button-container {
        text-align: right;
    }
}

.overlay {
    opacity: 0.2;
}

.actions {
    z-index: 3;
    width: 280px;
    top: 1rem;
    right: 0;
    left: 0;
    margin: 0 auto;
    border: solid 1px #8f8f8f;
    opacity: 1;
    > a {
        opacity: 1;
    }
}
.cell {
    font-size: 0.8rem;
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    //align-items: center;
}

.table th,
.table td {
    padding: 0.15rem;
}
@media #{$breakpoint-small} {
    .table th,
    .table td {
        padding: 0.45rem;
    }
}
@media #{$breakpoint-medium} {
    .table th,
    .table td {
        padding: 0.75rem;
    }
}

.loading-container {
    text-align: center;
}
</style>
